import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../utils/constants';

const WAPopup = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed) setVisible(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ type: 'spring', damping: 22, stiffness: 280 }}
          className="fixed bottom-40 md:bottom-24 right-3 md:right-6 z-50 w-72 bg-white rounded-2xl shadow-2xl border border-black/8 overflow-hidden"
        >
          {/* Header */}
          <div className="bg-[#25D366] px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                <MessageCircle size={16} color="white" />
              </div>
              <div>
                <p className="text-white font-black text-xs">PKRouteX Support</p>
                <div className="flex items-center gap-1">
                  <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                  <p className="text-white/80 text-[10px]">Online now</p>
                </div>
              </div>
            </div>
            <button onClick={() => { setVisible(false); setDismissed(true); }} className="text-white/80 hover:text-white transition-colors">
              <X size={16} />
            </button>
          </div>

          {/* Message bubble */}
          <div className="p-4">
            <div className="bg-brand-bg rounded-2xl rounded-tl-none px-4 py-3 mb-4">
              <p className="text-brand-black text-sm leading-relaxed">
                👋 Hi there! Need help booking a truck or getting a <span className="font-bold text-brand-orange">quick quote?</span>
              </p>
              <p className="text-brand-muted text-[10px] mt-1">Just now</p>
            </div>

            <a
              href={WHATSAPP_LINK('Hi PKRouteX! I need help with a booking.')}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setDismissed(true)}
              className="w-full flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 rounded-xl font-black text-xs tracking-wider hover:bg-green-500 transition-all"
            >
              <MessageCircle size={14} /> CHAT ON WHATSAPP
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WAPopup;
